import React, { Component } from "react";
import { translate } from "react-i18next";
import Home from "../components/HomeComponent";
import { connect } from "react-redux";
import { getHotels } from "../hotels/actions";
import Loader from "../components/Loader";
import { socketConnect } from "../messages/actions";
import {
  incrementDate,
  decrementDate,
  getOccupancy
} from "../rooms/occupancy/actions";
import { getSelectedHotel } from "../hotels/selectors";
import { LOADING } from "../utils/helpers/phases";
import { isSynchronizing } from "../users/selectors";
import { toggleMessage } from "../messages/actions";
import { getMessageVisibility } from "../messages/selectors";

class HomeContainer extends Component {
  async componentDidMount() {
    if (this.props.hotels.length === 0) {
      await this.props.getHotelInfo();
      if (this.props.hotels.length === 0) this.props.history.push("/hotel");
    }
    if (!this.props.socket) {
      this.props.socketConnect();
    }
  }
  render() {
    if (this.props.phase === LOADING) {
      return <Loader />;
    } else if (this.props.user && this.props.hotel) {
      return <Home {...this.props} />;
    } else {
      return <div />;
    }
  }
}

const mapStateToProps = state => {
  return {
    user: state.account.user,
    users: state.users.users,
    hotel: getSelectedHotel(state),
    legendMessageVisible: getMessageVisibility("legendMessage")(state),
    infoMessageVisible: getMessageVisibility("infoDashboardMessage")(state),
    hotels: state.hotels.data,
    phase: state.hotels.phase,
    socket: state.messages.socket,
    syncUser: state.synchronization,
    date: state.occupancy.date,

    isSynchronizing: isSynchronizing(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getHotelInfo: async () => {
      await dispatch(getHotels());
    },
    socketConnect: () => {
      dispatch(socketConnect());
    },
    incrementDate: () => {
      dispatch(incrementDate());
      dispatch(getOccupancy());
    },
    decrementDate: () => {
      dispatch(decrementDate());
      dispatch(getOccupancy());
    },
    toggleMessage: key => {
      dispatch(toggleMessage(key));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("translations")(HomeContainer));



// WEBPACK FOOTER //
// ./src/containers/HomeContainer.js